import React from 'react';

import { SaleLineRow } from '../SaleLineRow';
import type { CommissionOverrideInput, PosSaleLine } from '../../types';

export interface PosCartSectionProps {
  lines: PosSaleLine[];
  promotionLineAdjustments?: Record<number, { amount: number; label: string }>;
  totalLines: number;
  feedbackMessage: string | null;
  canOverrideCommission: boolean;
  showCommission: boolean;
  subscriptionsEnabled: boolean;
  customerId: number | null;
  onQuantityChange: (lineKey: string, quantity: number) => void;
  onRemoveLine: (lineKey: string) => void;
  onCommissionOverride: (itemId: number, override: CommissionOverrideInput) => void;
  onEditDiscount?: (itemId: number) => void;
  onProfessionalChange: (lineKey: string, professionalId: number | null) => void;
  onNotesChange: (lineKey: string, notes: string) => void;
}

export const PosCartSection: React.FC<PosCartSectionProps> = ({
  lines,
  promotionLineAdjustments = {},
  totalLines,
  feedbackMessage,
  canOverrideCommission,
  showCommission,
  subscriptionsEnabled,
  customerId,
  onQuantityChange,
  onRemoveLine,
  onCommissionOverride,
  onEditDiscount,
  onProfessionalChange,
  onNotesChange,
}) => (
  <section className="pos-panel pos-screen__cart-panel" aria-label="Líneas de venta actuales">
    <header className="pos-panel__header">
      <h2 className="pos-panel__title">Carrito</h2>
      <span className="pos-panel__meta">{totalLines} líneas</span>
    </header>
    {feedbackMessage ? <div role="status" className="pos-screen__feedback" aria-live="polite">{feedbackMessage}</div> : null}
    {lines.length > 0 ? (
      <ul className="pos-screen__cart-lines" aria-live="polite">
        {lines.map((line) => (
          <li key={line.lineKey}>
            <SaleLineRow
              line={line}
              promotionAdjustment={promotionLineAdjustments[line.item.id]}
              onQuantityChange={onQuantityChange}
              onRemoveLine={onRemoveLine}
              canOverrideCommission={canOverrideCommission}
              showCommission={showCommission}
              subscriptionsEnabled={subscriptionsEnabled}
              onCommissionOverride={onCommissionOverride}
              onEditDiscount={onEditDiscount}
              onProfessionalChange={onProfessionalChange}
              onNotesChange={onNotesChange}
              customerId={customerId}
            />
          </li>
        ))}
      </ul>
    ) : <p className="pos-screen__cart-empty">No hay ítems agregados.</p>}
  </section>
);

export default PosCartSection;
